import React from 'react';
import DataTable from '../../../ui/DataTable/DataTable';
import { CellText, CellId, CellPlate, CellNumber } from '../../../ui/DataTable/cells';
import Badge from '../../../ui/Badge';
import ContactPhone from '../../../components/ContactPhone';

const contractOf = (row) => row.contractNo || row.contract;

const ResultsList = ({ results, bookingIdMap, onSelectContract }) => {
    const columns = [
        { key: 'index', header: '#', width: 50, sortable: false, searchable: false, cell: (row, v, i) => <CellNumber value={i + 1} /> },
        {
            key: 'contractNo',
            header: 'Contract No.',
            accessor: contractOf,
            cell: (row) => {
                const cNo = contractOf(row);
                return (
                    <button
                        type="button"
                        onClick={() => onSelectContract(row)}
                        className="hover:underline"
                        title="Show contract details"
                    >
                        <CellId>{cNo}</CellId>
                    </button>
                );
            },
        },
        { key: 'bookingId', header: 'Booking ID', accessor: (row) => bookingIdMap.get(contractOf(row)) || '-', cell: (row, v) => <CellId>{v === '-' ? '' : v}</CellId> },
        { key: 'customer', header: 'Customer', accessor: (row) => row.customerName || row['Customer Name'], cell: (row, v) => <CellText>{v}</CellText> },
        {
            key: 'phone',
            header: 'Phone',
            sortable: false,
            searchable: false,
            cell: (row) => <ContactPhone contractNo={contractOf(row)} fallback={row.phone || row['Phone Number']} />,
        },
        {
            key: 'cars',
            header: 'Cars (Plate & Dates)',
            nowrap: false,
            sortable: false,
            accessor: (row) => (row.carDetails ? row.carDetails.map((c) => c.plateNumber).join(' ') : (row.cars || []).join(' ')),
            cell: (row) => (
                <ul className="flex flex-col gap-1 min-w-[260px]">
                    {row.carDetails && row.carDetails.map((car, i) => (
                        <li key={i} className="grid grid-cols-[1fr_auto] items-center gap-x-3">
                            <span>
                                <CellPlate>{car.plateNumber}</CellPlate>
                                {car.carModel ? <span className="ds-cell-text"> · {car.carModel}</span> : null}
                            </span>
                            <span className="ds-cell-date">{car.from} → {car.to}</span>
                        </li>
                    ))}
                    {!row.carDetails && row.cars && row.cars.map((c, i) => (
                        <li key={i}><CellPlate>{c}</CellPlate></li>
                    ))}
                </ul>
            ),
        },
        {
            key: 'carsCount',
            header: 'Cars Count',
            cell: (row) => <Badge variant={row.carsCount > 1 ? 'warning' : 'neutral'} size="sm">{row.carsCount} Cars</Badge>,
        },
    ];

    return (
        <DataTable
            columns={columns}
            data={results}
            rowKey={(row, i) => `${contractOf(row) || ''}|${i}`}
            searchable={false}
            card={false}
            emptyTitle="No results found"
            emptyDescription="Press Analyze System History."
        />
    );
};

export default ResultsList;
